export const fonts = {
    display: { value: "komu, sans-serif" },
    heading: { value: "infini, serif" },
    body: { value: "inter, sans-serif" },
    secondary: { value: "inter, sans-serif" }
};

export const semanticFonts = {
    komu: {
        DEFAULT: { value: "komu, sans-serif" }
    },
    infini: {
        DEFAULT: { value: "infini, serif" }
    },
    inter: {
        DEFAULT: { value: "inter, sans-serif" }
    }
};
